import React from 'react'
import {Icon} from '@chakra-ui/react'

const EmailIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M35.9042 32.8622H3.99579C2.34391 32.8622 1 31.5183 1 29.8665V10.9958C1 10.4358 1.15866 9.8852 1.4573 9.40923C2.00793 8.53196 2.95986 8 3.99579 8H35.9042C37.5561 8 38.9 9.34391 38.9 10.9958V29.8665C38.9 31.5183 37.5561 32.8622 35.9042 32.8622ZM3.99579 9.86654C3.60382 9.86654 3.24918 10.0625 3.03452 10.3985C2.92253 10.5758 2.86654 10.7811 2.86654 10.9958V29.8665C2.86654 30.4918 3.3705 30.9957 3.99579 30.9957H35.9042C36.5295 30.9957 37.0335 30.4918 37.0335 29.8665V10.9958C37.0335 10.3705 36.5295 9.86654 35.9042 9.86654H3.99579Z"
                fill="currentColor"
            />
            <path
                d="M19.8523 22.5777C19.6749 22.5777 19.4883 22.5217 19.3296 22.419L2.11083 10.8278C1.68153 10.5385 1.56954 9.95989 1.85885 9.53059C2.14816 9.10128 2.72679 8.98929 3.15609 9.2786L19.8523 20.5245L36.8564 9.18528C37.2857 8.89596 37.8643 9.01729 38.1536 9.44659C38.4429 9.87589 38.3216 10.4545 37.8923 10.7438L20.3655 22.4283C20.2069 22.531 20.0296 22.587 19.8523 22.587V22.5777Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default EmailIcon
